import React from "react";
import { createBrowserHistory } from "history";
import { Switch, Route } from "react-router";
import SubscriptionsPage from "./pages/SubscriptionsPage";

export const browserHistory = createBrowserHistory();

const SubscriptionsRouter: React.FC = () => {
  return (
    <Switch>
      <Route path="/subscriptions" component={SubscriptionsPage} />
    </Switch>
  );
};

export default SubscriptionsRouter;
